(() => {
  const initSlider = (slider) => {
    if (!slider || slider.dataset.mmReady === 'true') return;
    slider.dataset.mmReady = 'true';

    const track = slider.querySelector('[data-mm-offer-track]');
    const slides = Array.from(slider.querySelectorAll('[data-mm-offer]'));
    const status = slider.querySelector('[data-mm-copy-status]');
    let active = 0;
    let timer;

    const goTo = (index) => {
      if (!track || slides.length < 2) return;
      active = (index + slides.length) % slides.length;
      const trackRect = track.getBoundingClientRect();
      const slideRect = slides[active].getBoundingClientRect();

      // Keep autoplay scoped to the horizontal offer track. scrollIntoView()
      // can also move the page vertically when this section is off screen.
      track.scrollTo({
        left: track.scrollLeft + slideRect.left - trackRect.left,
        behavior: 'smooth',
      });
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      const delay = Number(slider.dataset.autoplay);
      if (delay > 0 && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => goTo(active + 1), delay);
      }
    };

    slider.querySelector('[data-mm-prev]')?.addEventListener('click', () => { goTo(active - 1); start(); });
    slider.querySelector('[data-mm-next]')?.addEventListener('click', () => { goTo(active + 1); start(); });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    slider.querySelectorAll('[data-mm-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const code = button.dataset.mmCopy || '';
        try {
          await navigator.clipboard.writeText(code);
        } catch (error) {
          const field = document.createElement('textarea');
          field.value = code;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          document.execCommand('copy');
          field.remove();
        }

        const original = button.querySelector('[data-mm-code-label]');
        button.classList.add('is-copied');
        if (original) original.textContent = 'Copied!';
        if (status) status.textContent = code + ' copied to clipboard';
        window.setTimeout(() => {
          button.classList.remove('is-copied');
          if (original) original.textContent = code;
        }, 1800);
      });
    });

    start();
  };

  const initPairSlider = (slider) => {
    if (!slider || slider.dataset.mmPairReady === 'true') return;
    slider.dataset.mmPairReady = 'true';

    const track = slider.querySelector('[data-mm-pair-track]');
    const previous = slider.querySelector('[data-mm-pair-prev]');
    const next = slider.querySelector('[data-mm-pair-next]');
    if (!track || !previous || !next) return;

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      previous.disabled = track.clientWidth === 0 || track.scrollLeft <= 1;
      next.disabled = track.clientWidth === 0 || track.scrollLeft >= maxScroll - 1;
    };

    const scrollByCard = (direction) => {
      const card = track.querySelector('.product-upsell-card');
      if (!card) return;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap) || 0;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollByCard(-1));
    next.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-mm-offer-slider]').forEach(initSlider);
    root.querySelectorAll('[data-mm-pair-slider]').forEach(initPairSlider);
  };
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => initAll())
    : initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
